import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';

import { SplashScreenPage } from './splash-screen';

@NgModule({
  declarations: [
    SplashScreenPage
  ],
  imports: [
    IonicPageModule.forChild(SplashScreenPage)
  ]
})
export class SplashScreenModule {}



// WEBPACK FOOTER //
// ./src/pages/splash-screen/splash-screen.module.ts